"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanDeep = void 0;
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const transform_1 = __importDefault(require("lodash/transform"));
function cleanDeep(object, params) {
    const { cleanKeys = [], cleanValues = [], emptyArrays = true, emptyObjects = true, emptyStrings = true, NaNValues = false, nullValues = true, undefinedValues = true, } = params || {};
    return (0, transform_1.default)(object, (result, value, key) => {
        // Exclude specific keys.
        if (cleanKeys.includes(key)) {
            return;
        }
        // Recurse into arrays and objects.
        if (Array.isArray(value) || (0, isPlainObject_1.default)(value)) {
            value = cleanDeep(value, {
                NaNValues,
                cleanKeys,
                cleanValues,
                emptyArrays,
                emptyObjects,
                emptyStrings,
                nullValues,
                undefinedValues,
            });
        }
        // Exclude specific values.
        if (cleanValues.includes(value)) {
            return;
        }
        // Exclude empty objects.
        if (emptyObjects && (0, isPlainObject_1.default)(value) && (0, isEmpty_1.default)(value)) {
            return;
        }
        // Exclude empty arrays.
        if (emptyArrays && Array.isArray(value) && !value.length) {
            return;
        }
        // Exclude empty strings.
        if (emptyStrings && value === '') {
            return;
        }
        // Exclude NaN values.
        if (NaNValues && Number.isNaN(value)) {
            return;
        }
        // Exclude null values.
        if (nullValues && value === null) {
            return;
        }
        // Exclude undefined values.
        if (undefinedValues && value === undefined) {
            return;
        }
        // Append when recursing arrays.
        if (Array.isArray(result)) {
            return result.push(value);
        }
        // eslint-disable-next-line
        // @ts-ignore
        // even though the types are correct, ts is complaining
        result[key] = value;
    });
}
exports.cleanDeep = cleanDeep;
